import React, {
    useState, 
    useEffect
} from 'react'
import GoogleMapReact from 'google-map-react';
import pinAvIcon from '../../assets/images/pin_available.svg'
import pinUnavIcon from '../../assets/images/pin_unavailable.svg'
import filterIcon from '../../assets/images/filter.svg'
import busIcon from '../../assets/images/parked.png';
import TakeTour from '../TakeTour/TakeTour';
import { 
    toast 
} from 'react-toastify';
import { useSelector } from 'react-redux';
import PanelListLoader from '../../utils/Loaders/PanelList';
import { useHistory } from 'react-router-dom';
import MapLoader from '../../utils/Loaders/MapLoader';
import checkIcon from '../../assets/images/circle_check.svg';
import pinbookedIcon from '../../assets/images/pin-booked.svg';
import iconLiveView from '../../assets/images/live.svg';
import wheatureIcon from '../../assets/images/wheather.svg';
import {formatDateNew, addMonths} from '../../utils/redableDateTime.js';
import closeIcon from '../../assets/images/closebtn.svg';
import { Get, Post } from '../../Api/ApiMethods.js';
import { 
    cancelBookingUrl,
    sendNotifyRequestMeUrl,
    getAllSlotsUrl,
    getParkingTypesUrl,
    getParkingDimensionsUrl,
 } from '../../Routes/ApiRoutes';

const getSatelliteView = (maps) => {

    return {
        streetViewControl: false,
        scaleControl: true,
        fullscreenControl: false,
        styles: [{
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{
                visibility: "off"
            }]
        }],
        gestureHandling: "greedy",
        disableDoubleClickZoom: true,
        minZoom: 2,
        //maxZoom: 18,
  
        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.SATELLITE,
        mapTypeControlOptions: {
            style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: maps.ControlPosition.BOTTOM_CENTER,
            mapTypeIds: [
                maps.MapTypeId.ROADMAP,
                maps.MapTypeId.SATELLITE,
                maps.MapTypeId.HYBRID
            ]
        },
  
        zoomControl: true,
        clickableIcons: false
    };
  }
  
export default function SiteMap() {
    const token = useSelector((state) => state.auth.isSignedIn);
    const history = useHistory();
    const [popupData, setPopupData] = useState(null);
    const [showTour, setShowTour] = useState(false);
    const [filter, setFilter] = useState(false);
    const [parkingTypes, setparkingType] = useState(null);
    const [dimensions, setDimesions] = useState(null);
    const [mapData, setMapData] = useState(null);
    const [sidePanelData, setSidePanelData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [listCount, setlistCount] = useState(0);
    const [showNofify, setShowNotify] = useState(false);
    const [cancelBook, setCancelBook] = useState(false);
    const [sidePanelFilterData, setSidePanelFilterData] = useState({
        "pageNo": currentPage,
        "pageSize": 10,
        "parkingType": -1,
        "parkingDimension": -1,
        "isAvailable": -1
    });

    function getDimensions (){
        try {
            Get(getParkingDimensionsUrl, token)
            .then(response => {
                if(response.status === 200){
                    setDimesions(response.data.rows);
                }
            })
            .catch(error => {
                toast.error(error.error)
            })
          }catch (error) {
            toast.error(error.error)
        }
    }

    function getAllSlots(){
        setPopupData(null)
        setSidePanelData(null);
        try {
            Post(getAllSlotsUrl, token, sidePanelFilterData)
            .then(response => {
                if(response.status === 200){
                    setSidePanelData(response.data.listView.rows);
                    setMapData(response.data.mapView.rows);
                    setlistCount(response.data.listView.count);
                }
            })
            .catch(error => {
                toast.error(error.error)
            })
          }catch (error) {
            toast.error(error.error)
        }
    }

    function getParkingtypes (){
        try {
            Get(getParkingTypesUrl, token)
            .then(response => {
                if(response.status === 200){
                    setparkingType(response.data.rows);
                }
            })
            .catch(error => {
                toast.error(error.error)
            })
          }catch (error) {
            toast.error(error.error)
        }
    }

    useEffect(() => {
        getDimensions();
        getParkingtypes();
    }, [])

    useEffect(() => {
        getAllSlots();
    }, [currentPage])
    


    function handleMarkerClick(e, item){
        setSidePanelData(null)
        setTimeout(() => {
            setPopupData(item);
            setSidePanelData([item]);
        } ,500);
    }
      
    function Marker ({ image, item }){
        return(
            <div key={item.id}>
                <img className='markerPin' onClick={(e) => handleMarkerClick(e,item)} src={image} />
            </div>
            )
    }

    function NotifyMesage() {
        return(
            <div className='notifyMesage'>
                <div className="generate-popup">
                    <span onClick={() => setShowNotify(!showNofify)}><img src={closeIcon}/></span>
                    <div className="img-circle">
                        <img src={checkIcon} />
                        <p>We will let you know once this place is available.</p>
                    </div>
                </div>
            </div>
        )
    }

    function CancelBookingPopUp(d) {
        return(
            <div className='notifyMesage'>
                <div className="generate-popup">
                    <span onClick={() => setCancelBook(!cancelBook)}><img src={closeIcon}/></span>
                    <div className="img-circle">
                        <p>Are you sure you want to cancel your booking for slot : {d.data.slotNumber} ?</p>
                        <div className="buttons-wrapper">
                            <div className="comman-btn">
                                <button onClick={() => handleCancelBooking(d)}>Yes, cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const handleCancelBooking = (d) => {
        let sendData = {
            "booking_id":d.data.bookings[0].id
        }
        try {
            Post(cancelBookingUrl, token, sendData)
            .then(res => {
                if(res.status === 200){
                    toast.success(res.message)
                    setShowTour(false);
                    setCancelBook(false);
                    setShowNotify(false);
                    getAllSlots();
                }
            })
            .catch(error => {
                toast.error(error.error)
                console.log(error);
            })
          }catch (error) {
            console.log(error);
        }
    }

    const handleNotify = (item) => {
        setShowTour(false);
        setCancelBook(false);
        var now = new Date();
        var isoDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString();
        const sendData = {
            "slot_id": item.id,
            "booking_date_time": isoDate
          }
        try {
            Post(sendNotifyRequestMeUrl, token, sendData)
            .then(res => {
                if(res.status === 200){
                    setShowNotify(true);
                }
            })
            .catch(error => {
                toast.error(error.error)
                console.log(error);
            })
          }catch (error) {
            console.log(error);
        }
    }

    function SidePanel() {
        return(
            sidePanelData ? sidePanelData.length > 0 ? sidePanelData.map((item) => {
                return(
                        <div onClick={(e) => !popupData && handleMarkerClick(e, item)} key={item.id} className="Covered-parking">
                            <div className={parseInt(item.status) === 1 ? 'availablePin' : !(item.is_paid) ? 'unavailablePin' : !(item.is_self_booked) ? 'unavailablePin' : 'yourBookin'}>
                                {parseInt(item.status) === 1 ? 'Available' : !(item.is_paid) ? 'Unavailable' : !(item.is_self_booked) ? 'Unavailable' : 'Your booking'}
                            </div>
                            <img className="img-fluid" src={item.slot_image ? item.slot_image : busIcon} />
                            <div className="transport-details">
                            {item.is_self_booked && <span className='bookinDate'>{formatDateNew(item.bookings[0].booking_date)}</span>}
                                <p>Space: <span>{item.slotNumber}</span></p>
                                <p>Type : <span>{item.parking_type.type}</span></p>
                                <p>Dimensions: <span>{item.parking_dimension.dimension}</span></p>
                                {popupData && <p>Price : <span>{item.price}</span></p>}
                                {item.is_self_booked  && <p>Validity: <span>{addMonths(new Date(item.bookings[0].booking_date), 1)}</span></p>}
                                <p>Description: <span className='description'>Beautiful lush green environment with shed to protect your vehicle from direct sunlight. Beautiful lush green environment with shed to protect your vehicle from direct sunlight.
                                {item.description}</span></p>
                                {popupData && item.is_self_booked  && <div className='liveView'>Live view of parking space <img src={iconLiveView}/></div>}
                                {popupData ? 
                                    item.status === 0 && item.is_paid && item.is_self_booked ? 
                                    <div className="buttons-wrapper">
                                        <div className="comman-btn">
                                            <button>Generate access code for vendors</button>
                                        </div>
                                        <div className="Cancel-booking">
                                            <button onClick={() => {
                                                setShowTour(false);
                                                setShowNotify(false);
                                                setCancelBook(true);
                                            }}>Cancel booking</button>
                                        </div>
                                    </div>
                                :
                                    <div className="buttons-wrapper">
                                            <div className="comman-btn">
                                                <button onClick={() => {
                                                    setShowTour(true);
                                                    setShowNotify(false);
                                                    setCancelBook(false);
                                                    }}>Take a tour</button>
                                            </div>
                                            {item.status === 1 ? 
                                                <div className="Book-now">
                                                    <button onClick={() => {
                                                        setTimeout(() => {
                                                            history.push({
                                                                pathname: `/booking/vehicleList/${item.id}`,
                                                                state :item
                                                            })
                                                        }, 1000)
                                                    }}>Book now</button>
                                                </div>
                                                :
                                                <div className="comman-btn">
                                                    <button onClick={() => handleNotify(item)} style={{marginTop : 18}}>Notify me</button>
                                                </div>
                                            }
                                    </div>
                                : ''}
                            </div>
                        </div>
                )
            }) : <p>No slots found</p> : <PanelListLoader />
        )
    }

    function popUp (item) {
          return  (
              <div className="mapNotify"> 
                  <span onClick={() => {
                      setPopupData(null);
                      getAllSlots();
                  }} 
                  className='closeMapNotify'><img src={closeIcon}/></span>
                  <p>Space: <span>{item.slotNumber}</span></p>
                  <p>Type : <span>{item.parking_type.type}</span></p>
                  <p>Dimensions: <span>{item.parking_dimension.dimension}</span></p>
                  <p>Status: <span>{parseInt(item.status) === 1 ? 'Available' : !(item.is_paid) ? 'Unavailable' : !(item.is_self_booked) ? 'Unavailable' : 'Your booking'}</span></p>
                  <span>{item.description}</span>
              </div>)
    }

    function filterPanel(){
        return(
            <>
                <div className='filterContainer'>
                    <div className='header'>
                        <span onClick={() => setFilter(!filter)} className='closebutton'><img src={closeIcon}/></span>
                        <span className='filtertext'>Filter</span>
                        <span onClick={() => resetFilter()} className=' Float float-right link'>Reset</span>
                    </div>
                    <div className='body' onClick={(e) => filterSelection(e)}>
                        <div >
                            <p className='text'>Parking Type</p>
                            <div id='parkingType' className='set'>
                                {parkingTypes && parkingTypes.map((item) => 
                                    <div className={parseInt(sidePanelFilterData.parkingType) === item.id ? 'buttonactive' : 'button'}
                                        id={item.id} key={item.id}>{item.type}</div>
                                )}
                            </div>
                        </div>

                        <div>
                            <p className='text'>Dimension (feet)</p>
                            <div id='parkingDimension' className='set'>
                                {dimensions && dimensions.map((item) => 
                                    <div className={parseInt(sidePanelFilterData.parkingDimension) === item.id ? 'buttonactive' : 'button'}
                                    id={item.id} key={item.id}>{item.dimension}</div>
                                )}
                            </div>
                        </div>
                
                        <div>
                            <p className='text'>Available</p>
                            <div id='isAvailable' className='set'>
                                <div id='-1' className={parseInt(sidePanelFilterData.isAvailable) === -1 ? 'buttonactive' : 'button'}>Show all</div>
                                <div id='1' className={parseInt(sidePanelFilterData.isAvailable) === 1 ? 'buttonactive' : 'button'}>Show available</div>
                            </div>
                        </div>

                        <div className="buttons-wrapper">
                                <div style={{marginTop : 30, textAlign: 'center'}} className="comman-btn">
                                    <button onClick={() => {
                                        getAllSlots();
                                        setFilter(false);
                                        setMapData(null);
                                    }}>Apply</button>
                                </div>
                        </div>

                    </div>

                </div>
            </>
        )
    }

    const filterSelection = (e) => {
        e.preventDefault();
        var parent = e.target.parentElement;
        if(parent.className === 'set')
        {
            var child = parent.childNodes;
            for(let j = 0; j < child.length ; j++)
            {
                let button = child[j]
                if(e.target !== button)
                {
                    button.className = 'button';
                }
            }
            let updatedDetails = { ...sidePanelFilterData };
            if(e.target.className === 'button'){
                e.target.className = 'buttonactive'
                updatedDetails[parent.id] = e.target.id;
            }
            else if(e.target.className === 'buttonactive'){
                e.target.className = 'button'
                updatedDetails[parent.id] = -1;
            }
            setSidePanelFilterData(updatedDetails)
            
        }
    }

    const resetFilter = () =>{
        const parkingType = document.getElementById('parkingType').childNodes;
        const dimension = document.getElementById('parkingDimension').childNodes;
        const available = document.getElementById('isAvailable').childNodes;

        setSidePanelFilterData({
            "pageNo": 1,
            "pageSize": 10,
            "parkingType": -1,
            "parkingDimension": -1,
            "isAvailable": -1
        })

        for(let j = 0; j < parkingType.length ; j++)
        {
            let button = parkingType[j]
             button.className = 'button';
        }
        for(let j = 0; j < dimension.length ; j++)
        {
            let button = dimension[j]
             button.className = 'button';
        }
        for(let j = 0; j < available.length ; j++)
        {
            let button = available[j]
             button.className = 'button';
        }
    }

    const handlePageChange = (e) => {
        let updatedDetails = { ...sidePanelFilterData };
        if(e.target.textContent == 'Next'){
            var nextPage = currentPage + 1
            setCurrentPage(nextPage);
            updatedDetails['pageNo'] = nextPage;
            setSidePanelFilterData(updatedDetails)
        }else if(e.target.textContent == 'Prev'){
            var prevPage = currentPage - 1
            setCurrentPage(prevPage);
            updatedDetails['pageNo'] = prevPage;
            setSidePanelFilterData(updatedDetails)
        }
    }

    return (
        <>
            <div className="container">
                <div style={{height: '700px'}} className="row no-gutters">
                    <div className="col-md-8 padding-rt">
                        <h2>BOOK PARKING SPACE</h2>

                        <div className="booking-place">
                            {cancelBook &&  <CancelBookingPopUp  data={popupData} />}
                            {showTour &&  <TakeTour data={popupData} hideTour={() => setShowTour(false)} />}
                            {showNofify && <NotifyMesage />}
                            <div style={{ height: '80vh', marginBottom:100, opacity : showTour || showNofify || cancelBook ?  0.2 : 1 }}>
                            {mapData ? 
                                <GoogleMapReact
                                className='cursor'
                                bootstrapURLKeys={{ key: process.env.React_App_Google_Map_Api_Key }}
                                defaultCenter={{
                                        lat: 28.656174,
                                        lng: 77.241024
                                    }}
                                defaultZoom={20}
                                options={getSatelliteView}>
                                {popupData &&  popUp(popupData)}
                                {mapData.map((item,index) =>
                                {
                                    return(
                                        <Marker lat={item.lat} lng={item.lng} 
                                        key={item.id}
                                        item={item}
                                        image={parseInt(item.status) === 1 ? pinAvIcon : !(item.is_paid) ? pinUnavIcon : !(item.is_self_booked) ? pinUnavIcon : pinbookedIcon}
                                        />
                                    )
                                })}
                                </GoogleMapReact>
                            : <MapLoader />}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 padding-lt" >
                        <div className="Filter float-right">
                            <p onClick={() => setFilter(!filter)}><img className="mr-2" src={filterIcon} /> Filter</p>
                        </div>
                        <div className="float-right tempmargin">
                            <a target='_blank' href='https://www.accuweather.com/en/us/rockledge/32955/weather-forecast/2245469'>
                                <img src={wheatureIcon} /> Weather information</a>
                        </div>
                        <div className='sideBar'>
                            {filter ? filterPanel() : <SidePanel /> }
                            
                            {filter || !popupData && listCount > 0 && <p>Showing page number {currentPage} out of {Math.ceil(listCount/10)}</p>}

                            {filter || !popupData && listCount > 0 &&
                                <div className='pagination'>
                                    <button onClick={(e) => handlePageChange(e) } 
                                    style={{display : currentPage === 1 ? 'none' : 'block'}}>Prev</button>
                                    <button onClick={(e) => handlePageChange(e)}
                                    style={{display : currentPage === Math.ceil(listCount/10) ? 'none' : 'block'}}>Next</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
    </>
    )
}


